
/* eslint-disable @typescript-eslint/camelcase */
import { Options, prop, Vue } from "vue-class-component";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { ModalMessageEntities } from "@/domain/entities/MainApp";

class Props {
  modelValue = prop<boolean>({ type: Boolean, default: false });
  currentEmail = prop<string>({ type: String, default: "" });
  errorMessageEmail = prop<string>({ type: String, default: "" });
  isSubmittingEmail = prop<boolean>({ type: Boolean, default: false });
  modelValuePassword = prop<boolean>({ type: Boolean, default: false });
  errorMessagePassword = prop<string>({ type: String, default: "" });
  isSubmittingPassword = prop<boolean>({ type: Boolean, default: false });
  isChangeEmailWizardEnabled = prop<boolean>({ type: Boolean, default: true });
}

@Options({
  emits: [
    "update:modelValue",
    "update:modelValuePassword",
    "submit-new-email",
    "submit-legacy-email",
    "password-confirmed",
    "close"
  ]
})
export default class ModalChangeEmail extends Vue.with(Props) {
  newEmail = "";
  password = "";
  passwordType = "password";

  get isEmailSubmitDisabled(): boolean {
    return !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.newEmail);
  }

  togglePasswordVisibility() {
    this.passwordType = this.passwordType === "password" ? "text" : "password";
  }

  onUserCloseEmail(bool: boolean) {
    if (!bool) {
      MainAppController.showMessageModal(
        new ModalMessageEntities({
          image: "badge-confirmation-general",
          title: this.$t("Yakin ingin keluar?"),
          message: this.$t("Semua perubahan yang belum disimpan akan dibatalkan."),
          onSubmit: () => {
            this.$emit("update:modelValue", false);
            this.$emit("close");
            this.resetState();
            MainAppController.closeMessageModal();
          },
          onClose: () => {
            MainAppController.closeMessageModal()
          },
          textSuccess: this.$t("Ya, batalkan"),
          textCancel: this.$t("Kembali"),
          customWidth: "417px",
          customButton: "w-full",
          customParentButton: "w-full",
          customWrapperButton: "w-full px-6",
        })
      );
    }
  }

  onUserClosePassword(bool: boolean) {
    if (!bool) {
      MainAppController.showMessageModal(
        new ModalMessageEntities({
          image: "badge-confirmation-general",
          title: this.$t("Yakin ingin keluar?"),
          message: this.$t("Semua perubahan yang belum disimpan akan dibatalkan."),
          onSubmit: () => {
            this.$emit("update:modelValuePassword", false);
            this.$emit("close");
            this.resetState();
            MainAppController.closeMessageModal();
          },
          onClose: () => {
            MainAppController.closeMessageModal()
          },
          textSuccess: this.$t("Ya, batalkan"),
          textCancel: this.$t("Kembali"),
          customWidth: "417px",
          customButton: "w-full",
          customParentButton: "w-full",
          customWrapperButton: "w-full px-6",
        })
      );
    }
  }

  onSubmitEmail() {
    if (this.isEmailSubmitDisabled) return;
    if (!this.isChangeEmailWizardEnabled) {
      this.$emit("submit-legacy-email", { new_email: this.newEmail });
      return;
    }
    this.$emit("submit-new-email", { new_email: this.newEmail });
    this.$emit("update:modelValue", false);
    this.$emit("update:modelValuePassword", true);
  }

  onSubmitPassword() {
    if (!this.password) return;
    this.$emit("password-confirmed", {
      new_email: this.newEmail,
      password: this.password
    });
  }

  resetState() {
    this.newEmail = "";
    this.password = "";
    this.passwordType = "password";
  }
}
